export default {
  contactsInformation: [],
};
